<template>
  <div class="home" id="div_home" v-if="rol != null">
    <div class="" v-if="campus != null">
      <div v-if="rol == 1" class="">
        <AdmisionComponet :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <div v-else-if="rol == 16" class="">
        <GerenciaComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles"/>
      </div>
      <div v-else-if="rol == 3" class="">
        <ConsultaComponent :rolname="rolname" :dataRoles="dataRoles" :rol_id="rol_id" />
      </div>
      <div v-else-if="rol == 5 " class="">
        <EmergenciaComponent :rolname="rolname" :dataRoles="dataRoles" :rol_id="rol_id" />
      </div>
      <div v-else-if="rol == 6" class="">
        <EnfermeriaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 8" class="">
        <AdministracionComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles" />
      </div>
      <div v-else-if="rol == 9" class="">
        <HopitalizacionComponent :rolname="rolname" :dataRoles="dataRoles" :rol_id="rol_id"  />
      </div>
      <div v-else-if="rol == 10" class="">
        <MedicoComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 11" class="">
        <PacienteComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <div v-else-if="rol == 12" class="">
        <PersonalComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <div v-else-if="rol == 13" class="">
        <ProcHospitalariosComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <div v-else-if="rol == 15" class="">
        <ServiciosComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <div v-else-if="rol == 17" class="">
        <LogisComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <div v-else-if="rol == 19" class="">
        <MaintenanceComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
    </div>
    <div class="" v-else>
      <CampusComponent
        :dataRoles="dataRoles"
        :dataCampus="dataCampus"
        @mtdSelectCampus="mtdSelectCampus"
        @mtdBackRol="mtdBackRol"
      />
    </div>
  </div>
  <div class="" v-else>
    <RolesVue :rol_id="rol_id" :dataRoles="dataRoles" @mtdSelectRol="mtdSelectRol" v-if="page != 'tareas_asignadas'"/>
    <FooterVue  @mtdChangePage="mtdChangePage" :pageView="page" @mtdBackCampus="mtdBackCampus" />
    <TareasVue v-if="page == 'tareas_asignadas'"  @mtdChangePage="mtdChangePage"  />
  </div>
</template>

<script>
import CampusComponent from "./Campus/index.vue";
import RolesVue from "./Rol/index.vue";
import GerenciaComponent from './Gerencia/GerenciaView.vue';
import MaintenanceComponent from "./Maintenance/MaintenanceView.vue";
import AsistencialComponent from './Asistencial/AsistencialView.vue';
import ConsultaComponent from './Consulta/ConsultaView.vue';
import HopitalizacionComponent from './Hospitalizacion/HospitalizacionView.vue';
import EmergenciaComponent from './Emergencia/EmergenciaView.vue';
import LogisticaComponent from './Logistica/LogisticaView.vue';
import PacienteComponent from './Paciente/PacienteView.vue';
import ServiciosComponent from './Servicios/ServiciosView.vue';
import JefeAdmisionComponent from "./JefeAdmision/JefeAdmisionView.vue";
import AdmisionComponet from './Admision/AdmisionView.vue'
import TesoreriaComponent from "./Tesoreria/TesoreriaView.vue";
import AdministracionComponent from "./Administracion/AdministracionView.vue"
import FacturacionComponent from "./Facturacion/FacturacionView.vue";
import DirectorComponent from "./Director/DirectorView.vue";
import FooterVue from "@/views/FooterView.vue";
import TareasVue from "../components/Tareas/Tareas.vue";
import RhComponent from "./Rh/RecursosHView.vue"; 
import JefaEnfermeriaComponent from "./JefaEnfermeria/JefaEnfermeriaView.vue";
import MedicoComponent from "./Medico/MedicoView.vue";
import EnfermeriaComponent from "./Enfermeria/EnfermeriaView.vue";
import PersonalComponent from "./Personal/PersonalView.vue";
import LogisComponent from "./Logis/LogisView.vue";
import ProcHospitalariosComponent from "./ProcHospitalarios/ProcHospitalariosView.vue";
import { mapActions } from 'vuex'

export default {
  name: 'HomeView',
  components: {
    CampusComponent,
    RolesVue,
    GerenciaComponent,
    MaintenanceComponent,
    AsistencialComponent,
    LogisticaComponent,
    PacienteComponent,
    JefeAdmisionComponent,
    AdmisionComponet,
    TesoreriaComponent,
    AdministracionComponent,
    FacturacionComponent,
    DirectorComponent,
    FooterVue,
    TareasVue,
    RhComponent,
    JefaEnfermeriaComponent,
    ConsultaComponent,
    EmergenciaComponent,
    HopitalizacionComponent,
    ServiciosComponent,
    MedicoComponent,
    EnfermeriaComponent,
    PersonalComponent,
    LogisComponent,
    ProcHospitalariosComponent
  },
  data () {
    return {
      page: "home",
      rol: null,
      rolname: null,
      dataCampus: [],
      campus: null,
      dataRoles: [],
      rol_id:null
    }
  },
  created () {
    const user = this.$store.getters.get__user

    if (user.roles.length == 1) {
      this.rol = user.roles[0].role_id;
      this.rolname = user.roles[0].role.name;
      this.rol_id = user.rol_id
    } else {
      this.dataRoles = user.roles;
      this.rolname = '';
      this.rol_id = user.rol_id
    }
    this.dataCampus = this.$store.getters.get__datacampus;
    this.mtdgetcheck();
  },
  methods: {
    ...mapActions(['get', 'post']),

    mtdSelectCampus: function (id) {
      this.campus = id;
      this.$store.commit("mt_set_campus", id);
    },
    mtdSelectRol: function (id, name_rol,rol_id) {
      this.rol = id;
      this.rolname = name_rol;
      this.rol_id = rol_id
      this.mtdgetcheck();
    },
    mtdBackRol: function () {
      this.rol = null;
    },
    mtdBackCampus: function () {
      this.campus = null;
      this.$store.commit("mt_set_campus", null);
    },
    mtdgetcheck: function () {
      this.get({
          url: this.$store.getters.get__url + "/Authentication/check",
          token: this.$store.getters.get__token,
        })
        .then((response) => {
          this.check = response.data.check;
          if(this.check){
            if(this.rol == 1){
              this.$router.push('/admision')
            }else
            if(this.rol == 2){
              this.$router.push('/caja')
            }else
            if(this.rol == 3){
              this.$router.push('/consulta')
            }else
            if(this.rol == 4){
              this.$router.push('/hospitalizacion')
            }else
            if(this.rol == 5){
              this.$router.push('/emergencia')
            }else
            if(this.rol == 6){
              this.$router.push('/enfermera')
            }else
            if(this.rol == 7){
              this.$router.push('/facturacion')
            }else
            if(this.rol == 8){
              this.$router.push('/historia-clinica')
            }else
            if(this.rol == 9){
              this.$router.push('/paciente')
            }else
            if(this.rol == 10){
              this.$router.push('/medico')
            }else
            if(this.rol == 11){
              this.$router.push('/paciente')
            }else
            if(this.rol == 12){
              this.$router.push('/personal')
            }else
            if(this.rol == 13){
              this.$router.push('/proc-hospitalario')
            }else
            if(this.rol == 14){
              this.$router.push('/proveedores')
            }else
            if(this.rol == 15){
              this.$router.push('/servicios')
            }else
            if(this.rol == 17){
              this.$router.push('/logistica')
            }else{
              this.$router.push('/home')
            }
          }else{
            this.$router.push('/login')
          }
        })
    },
    mtdChangePage: function (page) {
      this.page = page;
    },
  }
}
</script>